export default "__VITE_ASSET__fe7e983f__"